import React from 'react'

export default function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 30" {...props}>
      <g clipPath="url(#clip0_5277_21855)">
        <path
          fill="#000"
          d="M128.259 4.606h11.514V1.631h-11.514zm7.789-2.975v21.998h3.725V1.63zm-7.174 19.497q.37-.696.678-1.899.338-1.235.554-3.165.215-1.962.308-4.874l.307-9.56h-3.509l-.308 9.053q-.123 4.337-.554 6.805-.4 2.47-1.293 3.64zm-1.477 7.09v-4.59h10.898v4.59h3.479v-7.565h-17.857v7.565zM150.163 7.39q-3.017 0-4.926 2.153-1.908 2.12-1.908 6.14 0 2.66.861 4.526.863 1.836 2.402 2.786t3.571.95q3.018 0 4.926-2.121 1.91-2.153 1.909-6.172 0-2.66-.862-4.495-.862-1.836-2.402-2.785-1.539-.981-3.571-.981m0 13.58q-1.54 0-2.309-1.267-.738-1.266-.739-4.02 0-2.785.739-4.051.77-1.266 2.309-1.266t2.278 1.266q.77 1.266.77 4.02 0 2.785-.77 4.051-.738 1.266-2.278 1.266M166.108 23.944q1.262 0 2.186-.253a4.3 4.3 0 0 0 1.601-.728v-3.07a5.8 5.8 0 0 1-1.57.791q-.862.285-2.001.285-1.97 0-2.833-1.456-.862-1.455-.862-3.925 0-2.595.955-3.893.985-1.33 2.77-1.33 1.047 0 2.001.317.985.317 1.54.665V8.15q-.585-.348-1.601-.538-.986-.221-2.34-.221-2.34 0-3.941 1.076-1.57 1.044-2.37 2.912-.801 1.868-.801 4.304 0 3.989 1.786 6.14 1.817 2.121 5.48 2.121M183.565 10.682V7.707h-12.284v2.975h4.31v12.946h3.663V10.682zM192.717 19.83q-.338.507-.986.887-.646.38-1.631.38-1.17 0-1.755-.602-.554-.633-.554-1.645 0-1.361 1.016-1.9 1.046-.57 3.386-.57h.524zm3.663-7.057q0-2.88-1.447-4.084-1.446-1.233-4.341-1.234-1.816 0-3.232.475-1.386.474-2.217.981v3.133q.492-.38 1.293-.727a9.2 9.2 0 0 1 1.817-.602 7.7 7.7 0 0 1 1.908-.253q1.324 0 1.94.538t.616 1.804v.886h-.585q-4.187 0-6.158 1.361-1.94 1.361-1.939 3.767t1.293 3.735q1.323 1.297 3.448 1.297 1.632 0 2.432-.443.831-.474 1.355-1.044h.154q.03.315.092.665.092.348.185.6h3.571a42 42 0 0 1-.185-3.892zM205.728 23.628q2.71 0 4.249-1.171t1.539-3.45q0-1.773-1.108-2.69-1.108-.95-3.079-1.077l.062.285q1.6-.254 2.555-1.171.985-.95.985-2.596 0-4.05-5.141-4.051h-4.987v2.785h4.556q2.063 0 2.063 1.836 0 .823-.585 1.298-.554.475-1.601.475h-4.403v2.753h4.587q2.402 0 2.402 1.9 0 1.107-.647 1.614-.647.474-1.755.474h-4.587v2.786zm-6.403-15.921v15.92h3.571V7.708zM223.049 23.628h4.157l-5.88-8.451 5.172-7.47h-3.694l-5.172 7.47v-7.47h-3.665v15.92h3.665v-7.69zM236.04 19.83q-.339.507-.985.887-.647.38-1.633.38-1.169 0-1.755-.602-.553-.633-.554-1.645 0-1.361 1.017-1.9 1.047-.57 3.386-.57h.524zm3.663-7.057q0-2.88-1.447-4.084-1.445-1.233-4.341-1.234-1.817 0-3.233.475-1.384.474-2.216.981v3.133q.492-.38 1.294-.727a9.2 9.2 0 0 1 1.816-.602 7.7 7.7 0 0 1 1.908-.253q1.324 0 1.941.538.615.538.615 1.804v.886h-.586q-4.187 0-6.157 1.361-1.939 1.361-1.939 3.767t1.292 3.735q1.325 1.297 3.449 1.297 1.633 0 2.431-.443.832-.474 1.356-1.044h.154q.03.315.091.665.095.348.186.6h3.572a42 42 0 0 1-.186-3.892zM25.861 7.708v6.299h-4.895v-6.3h-3.664V23.63h3.664v-6.647h4.895v6.647h3.664V7.708zm20.196 12.945h-1.631V7.708H33.742v1.361q0 1.962-.122 4.146a38 38 0 0 1-.462 4.147q-.309 1.962-.955 3.291h-1.139v6.616h3.387v-3.64h8.22v3.64h3.386zm-5.295 0H35.59q.492-1.201.77-2.88.307-1.71.4-3.45a46 46 0 0 0 .123-3.165v-.475h3.879zm8.713-3.64h10.098V15.02q0-2.786-.74-4.43-.738-1.68-2.093-2.438-1.354-.76-3.201-.76-2.217 0-3.695 1.077-1.447 1.076-2.186 2.975-.708 1.868-.708 4.273 0 4.146 1.909 6.204 1.91 2.025 5.418 2.025 1.755 0 3.048-.411 1.293-.412 2.094-.982v-3.07q-.862.602-2.186 1.045a8.1 8.1 0 0 1-2.648.443q-2.155 0-3.017-1.108-.831-1.14-.831-3.45V14.64q0-4.273 2.74-4.273 1.355 0 1.847 1.044.523 1.013.523 2.5v1.077l1.232-.76h-7.604zm21.643 6.616h4.156l-5.88-8.451 5.172-7.47h-3.694l-5.173 7.47v-7.47h-3.663v15.92h3.663v-7.69zm11.206.316q1.262 0 2.186-.253a4.3 4.3 0 0 0 1.601-.728v-3.07a5.8 5.8 0 0 1-1.57.791q-.863.285-2.001.285-1.97 0-2.833-1.456-.862-1.455-.862-3.925 0-2.595.955-3.893.985-1.33 2.77-1.33 1.048 0 2.002.317.985.317 1.54.665V8.15q-.585-.348-1.602-.538-.985-.222-2.34-.222-2.34 0-3.94 1.077-1.57 1.043-2.371 2.912-.8 1.867-.8 4.304 0 3.989 1.785 6.14 1.817 2.121 5.48 2.121m-71.826-.316h3.726V1.63H8.805q-4.095 0-6.219 1.994Q.493 5.587.493 8.752q0 2.533 1.139 4.21t3.232 3.229L0 23.629h4.033l5.419-8.325-1.878-1.297a16.4 16.4 0 0 1-1.91-1.52 5.2 5.2 0 0 1-1.108-1.677q-.369-.95-.369-2.28 0-1.74 1.17-2.816 1.2-1.108 3.479-1.108h1.662z"
        ></path>
        <mask
          id="mask0_5277_21855"
          width="30"
          height="30"
          x="90"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{maskType: 'luminance'}}
        >
          <path
            fill="#fff"
            d="M105.303 0C97.249 0 90.72 6.713 90.72 14.993s6.529 14.993 14.583 14.993 14.584-6.712 14.584-14.993c0-8.28-6.529-14.993-14.584-14.993"
          ></path>
        </mask>
        <g mask="url(#mask0_5277_21855)">
          <path
            fill="#000"
            d="M105.303 0C97.249 0 90.72 6.713 90.72 14.993s6.529 14.993 14.583 14.993 14.584-6.712 14.584-14.993c0-8.28-6.529-14.993-14.584-14.993"
          ></path>
          <mask
            id="mask1_5277_21855"
            width="38"
            height="42"
            x="82"
            y="-6"
            maskUnits="userSpaceOnUse"
            style={{maskType: 'alpha'}}
          >
            <path
              fill="#C4C4C4"
              d="m83.33 5.103 16.387-9.91a2.45 2.45 0 0 1 2.546 0l16.388 9.91a2.6 2.6 0 0 1 1.237 2.224v15.334c0 .914-.471 1.76-1.237 2.224l-16.388 9.91a2.45 2.45 0 0 1-2.546 0l-16.387-9.91a2.6 2.6 0 0 1-1.238-2.224V7.327c0-.914.471-1.76 1.238-2.224"
            ></path>
          </mask>
          <g mask="url(#mask1_5277_21855)">
            <path
              fill="url(#paint0_linear_5277_21855)"
              d="M100.99-5.576 82.092 5.852l18.898 11.429 18.898-11.429z"
            ></path>
            <path fill="url(#paint1_radial_5277_21855)" d="M82.092 24.137V5.852L100.99 17.28v18.286z"></path>
            <path fill="url(#paint2_radial_5277_21855)" d="M119.888 24.137V5.852L100.99 17.28v18.286z"></path>
            <path
              fill="url(#paint3_radial_5277_21855)"
              fillRule="evenodd"
              d="m91.295-3.46 21.254 12.992c.415.254.67.713.67 1.21V33.28h-5.558V13.992c0-.496-.255-.956-.67-1.21L88.454 1.451z"
              clipRule="evenodd"
            ></path>
          </g>
          <path
            fill="#000"
            fillRule="evenodd"
            d="m96.009 5.145.487-.214 1.952 1.143.906-.5-1.952-1.143.488-.286-3.136-.785zm2.3-1.285.487-.286 1.951 1.143.976-.429-1.951-1.214.487-.286-3.135-.714zm.069 2.714 4.181-2.357.418.285-4.181 2.357zM103.264 9.712c-1.101-.78-.963-1.915.206-2.553 1.17-.709 3.027-.567 4.059.213.895.638.826 1.702 1.032 3.262 0 .141-.137.212-.344.212-1.788-.354-3.852-.425-4.953-1.134m3.027-.497c.55-.283.55-.85.069-1.205s-1.307-.425-1.858-.07c-.55.283-.55.85-.069 1.204.482.284 1.308.355 1.858.071"
            clipRule="evenodd"
          ></path>
          <path
            fill="#000"
            d="m112.099 12.762-1.594.912-.191.661.593-.322-.796 2.33.203-1.693-.572.3.167-.893-1.347.791c.005.203.021.743.044 1.282.072 1.868 1.141 1.898 1.492 1.856.004.247.09 1.106-.127 1.598-.217.491-.613.62-.961.868-.186.134-.086.414.292.217.377-.197 1.746-1.049 2.198-1.274.232-.116.267-.444-.102-.276-1.016.465-.893-.33-.893-.612s-.004-.356 0-.696c1.56-2.098 1.713-4.24 1.594-5.05"
          ></path>
          <path
            fill="#000"
            fillRule="evenodd"
            d="m108.562 25.758.422-.216v2.443l.843-.503V25.04l.421-.215-.842-2.228zm2.038-1.15.421-.216v2.443l.843-.503V23.89l.422-.216-.913-2.299zm-2.038 4.167 3.654-2.155v.575l-3.654 2.155z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint1_radial_5277_21855"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-13.46467 -16.45706 15.34031 -12.55098 100.163 34.194)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CA8D32"></stop>
          <stop offset="1" stopColor="#F2C888"></stop>
        </radialGradient>
        <radialGradient
          id="paint2_radial_5277_21855"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(21.2285 -11.31387 10.38624 19.48796 95.88 28.023)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4892F"></stop>
          <stop offset="1" stopColor="#E6BE81"></stop>
        </radialGradient>
        <radialGradient
          id="paint3_radial_5277_21855"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(31.465 41.094 158.477)scale(27.3686 20.297)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6E8"></stop>
          <stop offset="0.678" stopColor="#FFF9EF"></stop>
          <stop offset="1" stopColor="#F0DBBC"></stop>
        </radialGradient>
        <linearGradient
          id="paint0_linear_5277_21855"
          x1="100.234"
          x2="101.557"
          y1="-4.342"
          y2="13.853"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE7C2"></stop>
          <stop offset="1" stopColor="#E3B673"></stop>
        </linearGradient>
        <clipPath id="clip0_5277_21855">
          <path fill="#fff" d="M0 0h240v30H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
}
